<template>
  <button @click="emit('scrollToBottom')" :class="classButtonScroll">
    <IconApecScrollDown class="icon-dim icon-medium" />
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import IconApecScrollDown from '@/components/icons/IconApecScrollDown.vue';
import { useSocketStore } from '@/stores/socket';

const socketStore = useSocketStore();

const classButtonScroll = computed(() => {
  return socketStore.connectInfo?.connectionType === 'SCREEN'
    ? 'scroll-down'
    : 'floating-button';
});

const emit = defineEmits<{
  scrollToBottom: [];
}>();
</script>

<style lang="scss" scoped>
.floating-button {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  right: 1rem;
  padding: 0.75rem;
  background-color: var(--surface-glass-dimmer);
  backdrop-filter: blur(4px);
  border-radius: 100px;
  outline: solid 1px var(--border-dimmer);
  align-items: center;
  z-index: $z-floating;
}

.scroll-down {
  position: fixed;
  bottom: 3rem;
  right: 2rem;
  z-index: $z-floating;
  background-color: var(--surface-glass-dimmest);
  border-radius: 20px;
  padding: 0.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.scroll-down svg {
  width: 1.25rem;
  height: 1.25rem;
}
</style>
